export default __webpack_public_path__ + "static/35-2b82d4da989f629b3c7dd291deaf57ce.gif";